import { getMultipleRefCompsIdFromInflatedId, getUniqueId } from '@wix/thunderbolt-commons'
import { createConsumptionDataNode } from './utils/dataNodeUtils'
import type { Ref } from '@wix/thunderbolt-types'
import type { StateVariant, TriggerVariant, unresolvedVariantQueries } from '@wix/thunderbolt-becky-types'
import { RESOLVED_REFS_NAMESPACE, VARIANTS_INFLATED_MAP } from '../../../constants'
import type { Unref } from '@wix/thunderbolt-catharsis'
import { removeHash } from '@wix/thunderbolt-catharsis'
import type { DataItemWithOverridesRefs } from '../../types'
import { getOverrideItem } from '../../dataConsumption'

type RefConsumptionDependencies = Ref<TriggerVariant | StateVariant>

export const Variants = createConsumptionDataNode<null, null, RefConsumptionDependencies | DataItemWithOverridesRefs>({
	updateDependencies: ({ update, inflatedComponent, dependencies }) => {
		update(
			RESOLVED_REFS_NAMESPACE,
			VARIANTS_INFLATED_MAP,
			inflatedComponent.variantsQuery,
			dependencies,
			dependencies
		)
	},
	toViewItem: ({ id, value, aspect }) => {
		const ancestorsChain = getMultipleRefCompsIdFromInflatedId(id)
		if (!value) {
			return
		}
		if (aspect === 'variantIdInflatedMap') {
			const { dataItemWithOverrides } = value as Unref<DataItemWithOverridesRefs>
			const templateDataItem = getOverrideItem(dataItemWithOverrides) as unresolvedVariantQueries
			if (!templateDataItem) {
				return
			}
			return {
				[id]: {
					...templateDataItem,
					componentId: getUniqueId(ancestorsChain, templateDataItem.componentId),
					id,
					values: templateDataItem.values.map((variant) => getUniqueId(ancestorsChain, removeHash(variant))),
				},
			}
		}

		const inflatedEffect =
			'params' in value && 'effect' in value.params!
				? `#${getUniqueId(ancestorsChain, removeHash(value.params.effect))}`
				: undefined

		return {
			...value,
			componentId: getUniqueId(ancestorsChain, (value as Unref<RefConsumptionDependencies>).componentId),
			...(inflatedEffect && { params: { effect: inflatedEffect } }),
			id,
		}
	},
})
